import * as React from "react";
import {cs} from "../../../../react/chain-services";
import "./ml-addresses-table.scss";
import {DataTableD1} from "../../common/design2/data-table/data-table-d1";
import {cx} from "emotion";
import {PageSize} from "../../common/design2/pagination-ui/page-size/page-size";
import {PageList} from "../../common/design2/pagination-ui/page-list/page-list";
import {Badge} from "../../common/design2/badge/badge";
import {UseState} from "../../../../react/use-state";
import {ConfirmDialog} from "../../common/design2/dialogs/confirm-dialog/confirm-dialog";
import {AddressModalA} from "./address-modal-a";
import {EditActionInTable} from "../../common/design2/data-table-ui/edit-action-in-table/edit-action-in-table";
import {DeleteActionInTable} from "../../common/design2/data-table-ui/delete-action-in-table/delete-action-in-table";
import {upperCase1, upperCase2} from "../../../../utils/strings";

export const MLAddressesTable = ({data, loading, onAdd, countryCode, onEdit, onDelete, xdQaNamePrefix=undefined}) => cs(
    ["confirmDialog", (_, next) => ConfirmDialog({next})],
    ["addressModal", (_, next) => AddressModalA({next})],
    ["pageSize", (_, next) => UseState({initValue: 10, next})],
    ({pageSize, confirmDialog, addressModal}) => DataTableD1({
        darkRows: "even",
        getDefaultSorting: () => ({
            columnIndex: 4,
            direction: "desc",
        }),
        className: cx("ml-addresses-table-13h"),

        columns: Columns({countryCode, xdQaNamePrefix}),
        rows: data?.map((r) => ({
            key: r.idPrimary,
            columns: [
                countryCode !== "CA" && {
                    render: () => (
                        !r.status ? null : (() => {
                            const status = r.status.toUpperCase();
                            return (
                                status === "PASSED" ? (
                                    Badge({color: "green", text: "Good", xdQaName: (xdQaNamePrefix ? xdQaNamePrefix+" " : "")+r.address+" Good"})
                                ) : status === "CHANGED" ? (
                                    Badge({color: "orange", text: upperCase2(r.status), xdQaName: (xdQaNamePrefix ? xdQaNamePrefix+" " : "")+r.address+" Warning"})
                                ) : (
                                    Badge({color: "red", text: upperCase2(r.status), xdQaName: (xdQaNamePrefix ? xdQaNamePrefix+" " : "")+r.address+" Failed"})
                                )
                            );
                        })()
                    ),
                    sortValue: () => r.status?.toUpperCase(),
                },
                {
                    render: () => r.name2 ? (
                        <>
                            <div>{r.name}</div>
                            <div>{r.name2}</div>
                        </>
                    ) : (
                        r.name
                    ),
                    sortValue: () => r.name.toLowerCase(),
                    domAttrs: {
                        "xd-qa-type": "label",
                        "xd-qa-name": (xdQaNamePrefix ? xdQaNamePrefix+" " : "")+r.address+" Recipient Name",
                    },
                },
                {
                    render: () => r.address,
                    sortValue: () => r.address.toLowerCase(),
                    domAttrs: {
                        "xd-qa-type": "label",
                        "xd-qa-name": (xdQaNamePrefix ? xdQaNamePrefix+" " : "")+r.address,
                    },
                },
                {
                    render: () => r.address2,
                    sortValue: () => r.address2.toLowerCase(),
                    domAttrs: {
                        "xd-qa-type": "label",
                        "xd-qa-name": (xdQaNamePrefix ? xdQaNamePrefix+" " : "")+r.address+" address2",
                    },
                },
                {
                    render: () => r.city,
                    sortValue: () => r.city.toLowerCase(),
                    domAttrs: {
                        "xd-qa-type": "label",
                        "xd-qa-name": (xdQaNamePrefix ? xdQaNamePrefix+" " : "")+r.address+" City",
                    },
                },
                {
                    render: () => r.state,
                    sortValue: () => r.state.toLowerCase(),
                    domAttrs: {
                        "xd-qa-type": "label",
                        "xd-qa-name": (xdQaNamePrefix ? xdQaNamePrefix+" " : "")+r.address+" State",
                    },
                },
                {
                    render: () => r.zip,
                    sortValue: () => r.zip.toLowerCase(),
                    domAttrs: {
                        "xd-qa-type": "label",
                        "xd-qa-name": (xdQaNamePrefix ? xdQaNamePrefix+" " : "")+r.address+" Zip",
                    },
                },
                {
                    render: () => <>
                        {EditActionInTable({
                            onClick: () => {
                                addressModal.show({
                                    actionName: "edit",
                                    countryCode,
                                    onConfirm: (edited) => {
                                        return onEdit(edited);
                                    },
                                    initData: r,
                                });
                            },
                            xdQaName: (xdQaNamePrefix ? xdQaNamePrefix+" " : "")+r.address,
                        })}
                        {DeleteActionInTable({
                            onDelete: async () => {
                                if (await confirmDialog.show({
                                    message: `Deleting address: ${r.address}`,
                                    actionName: "delete",
                                    buttons: {
                                        confirmLabel: "Yes",
                                    },
                                })) {
                                    await onDelete(r);
                                }
                            },
                            xdQaName: (xdQaNamePrefix ? xdQaNamePrefix+" " : "")+r.address,
                        })}
                    </>,
                },
            ].filter(v=>v),
        })),
        emptyAction: {
            label: loading? "Loading..." : "No addresses",
        },
        pageSize: pageSize.value,
        getFooter: ({colCount, pagination}) => ({
            columns: [
                {
                    colSpan: colCount,
                    render: () => (
                        <div className="controls">
                            {PageSize({state: pageSize, xdQaNamePrefix})}

                            {pagination.active && (
                                <div className="page-list">
                                    {PageList({...pagination, xdQaNamePrefix})}
                                </div>
                            )}

                            <div className="buttons">
                                <button {...{
                                    onClick: () => {
                                        addressModal.show({
                                            actionName: "add",
                                            countryCode,
                                            onConfirm: (r, action) => {
                                                return action === 'edit' ? onEdit(r) : onAdd(r);
                                            },
                                        })
                                    },
                                    "xd-qa-type": "button",
                                    "xd-qa-name": (xdQaNamePrefix ? xdQaNamePrefix+" " : "")+"ADD NEW ADDRESS",
                                }}>
                                    ADD NEW ADDRESS
                                </button>
                            </div>
                        </div>
                    ),
                },
            ],
        }),
    }),
);


const Columns = ({countryCode, xdQaNamePrefix}) => [
    countryCode !== "CA" && {
        width: "1%",
        className: "status",
        label: "STATUS",
        sortable: {
            defaultDirection: "asc",
        },
        domAttrs: {
            "xd-qa-type": "label",
            "xd-qa-name": (xdQaNamePrefix ? xdQaNamePrefix+" " : "")+"Status",
        },
    },
    {
        width: "3%",
        label: "RECIPIENT NAME",
        className: "name",
        sortable: {
            defaultDirection: "asc",
        },
        domAttrs: {
            "xd-qa-type": "label",
            "xd-qa-name": (xdQaNamePrefix ? xdQaNamePrefix+" " : "")+"Recipient Name",
        },
    },
    {
        width: "3%",
        label: "ADDRESS",
        className: "address",
        sortable: {
            defaultDirection: "asc",
        },
        domAttrs: {
            "xd-qa-type": "label",
            "xd-qa-name": (xdQaNamePrefix ? xdQaNamePrefix+" " : "")+"Address",
        },
    },
    {
        width: "3%",
        label: "ADDRESS2",
        className: "address2",
        sortable: {
            defaultDirection: "asc",
        },
        domAttrs: {
            "xd-qa-type": "label",
            "xd-qa-name": (xdQaNamePrefix ? xdQaNamePrefix+" " : "")+"Address2",
        },
    },
    {
        width: "3%",
        label: "CITY",
        className: "city",
        sortable: {
            defaultDirection: "asc",
        },
        domAttrs: {
            "xd-qa-type": "label",
            "xd-qa-name": (xdQaNamePrefix ? xdQaNamePrefix+" " : "")+"City",
        },
    },
    {
        width: "1%",
        label: countryCode === "CA" ? "PROVINCE" : "STATE",
        className: "state",
        sortable: {
            defaultDirection: "asc",
        },
        domAttrs: {
            "xd-qa-type": "label",
            "xd-qa-name": (xdQaNamePrefix ? xdQaNamePrefix+" " : "")+(countryCode === "CA" ? "PROVINCE" : "STATE"),
        },
    },
    {
        width: "1%",
        label: "ZIP CODE",
        className: "zip",
        sortable: {
            defaultDirection: "asc",
        },
        domAttrs: {
            "xd-qa-type": "label",
            "xd-qa-name": (xdQaNamePrefix ? xdQaNamePrefix+" " : "")+"Zip Code",
        },
    },
    {
        width: "1%",
        label: "ACTION",
        className: "actions",
        domAttrs: {
            "xd-qa-type": "label",
            "xd-qa-name": (xdQaNamePrefix ? xdQaNamePrefix+" " : "")+"Action",
        },
    },
].filter(v=>v);